// ----------------------------------------------------------------------
// <copyright file="Izenda.MobxUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var m = require('mobx');

  /**
    * Basically, a deep clone, so that no reactive property will exist anymore.
    * This is a customized of https://github.com/mobxjs/mobx/blob/master/src/api/tojs.ts
    * Only use for mobx ver. 2.1.7
    */
  function toJS(source, detectCycles, __alreadySeen) {
    "use strict";

    if (typeof m.toJS === 'function') {
      return m.toJS(source, detectCycles, __alreadySeen);
    }

    var isObservableValue = function (i) {
      return typeof i.get === "function";
    }

    if (!source ||
      source instanceof Date ||
      source instanceof RegExp) {
      return source;
    }

    if (Array.isArray(source) || m.isObservableArray(source)) {
      const res = [];
      const toAdd = source.map(function (value) {
        return toJS(value);
      });
      res.length = toAdd.length;
      for (let i = 0, l = toAdd.length; i < l; i++) {
        res[i] = toAdd[i];
      }
      return res;
    }
    if (m.isObservableMap(source)) {
      const res = {};
      source.forEach(function (value, key) {
        return res[key] = toJS(value);
      });
      return res;
    }

    if (m.isObservable(source) && isObservableValue(source.$mobx))
      return toJS(source());

    if (isObservableValue(source))
      return toJS(source.get());

    if (typeof source === "object") {
      const res = {};
      for (const key in source)
        res[key] = toJS(source[key]);
      return res;
    }
    return source;
  }

  module.exports = {
    toJS: toJS
  };
} ());


// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.MobxUtils.js